import { render } from "./TabContainer.vue?vue&type=template&id=6c3ee66e&ts=true"
import script from "./TabContainer.vue?vue&type=script&lang=ts"
export * from "./TabContainer.vue?vue&type=script&lang=ts"

import "./TabContainer.vue?vue&type=style&index=0&id=6c3ee66e&lang=less"

import exportComponent from "/home/joshua/extrafiles/Stuffs/repos/work/ada/adaplus-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__